export const payroll = [
    {
        id: "P738197",
        name: "Kevin",
        department: "Admin",
        designation: "Technical Head",
        phone: "+601 63423 72397",
        amount: "RM15,000",
        status: "Paid",
        details: "View Payslip",
    },
      {
        id: "P738197",
        name: "Willie",
        department: "Management",
        designation: "Receptionist",
        phone: "+601 82913 61371",
        amount: "RM12,000",
        status: "Generated",
        details: "View Details",
    },
      {
        id: "P738196",
        name: "Daniel",
        department: "Management",
        designation: "Admin",
        phone: "+601 56752 86742",
        amount: "RM13,000",
        status: "Paid",
        details: "View Payslip"
    },
      {
        id: "P738195",
        name: "Teresa",
        department: "Management",
        designation: "Admin",
        phone: "+601 82392 37359",
        amount: "RM13,000",
        status: "Paid",
        details: "View Payslip"
    },
      {
        id: "P738194",
        name: "Johnson",
        department: "Finance",
        designation: "Accountant",
        phone: "+601 53619 54691",
        amount: "RM18,000",
        status: "Paid",
        details: "View Payslip"
    },
      {
        id: "P738193",
        name: "Hellana",
        department: "Management",
        designation: "HR Manager",
        phone: "+601 23566 52683",
        amount: "RM12,000",
        status: "Generated",
        details: "View Details"
    },
      {
        id: "P738192",
        name: "James",
        department: "Library",
        designation: "Librarian",
        phone: "+601 78429 82414",
        amount: "RM10,000",
        status: "Paid",
        details: "View Payslip"
    },
      {
        id: "P738191",
        name: "Jacquelin",
        department: "Transport",
        designation: "Driver",
        phone: "+601 77502 54845",
        amount: "RM8000",
        status: "Paid",
        details: "View Payslip"
    },
      {
        id: "P738190",
        name: "Edward",
        department: "Finance",
        designation: "Accounts Manager",
        phone: "+601 56187 87489",
        amount: "RM12,000",
        status: "Paid",
        details: "View Details"
    },
      {
        id: "P738189",
        name: "Elizabeth",
        department: "Management",
        designation: "Receptionist",
        phone: "+601 97846 84518",
        amount: "RM10,000",
        status: "Paid",
        details: "View Details"
    }
]
